import { USER_ROLE } from 'utils/constants'

const { MANAGER } = USER_ROLE

export const getProjectUsersByStatus = (users = []) => {
  const { activeUsers, inactiveUsers } = users.reduce(
    (acc, user) => {
      acc[user.is_deactivated ? 'inactiveUsers' : 'activeUsers'].push(user)

      return acc
    },
    {
      activeUsers: [],
      inactiveUsers: [],
    }
  )

  const activeManagersCount = activeUsers.filter((user) =>
    user.role?.some((role) => role?.id === MANAGER)
  ).length

  return { activeUsers, inactiveUsers, activeManagersCount }
}
